@if (!!nodes.length) {
<ngx-graph
    [links]="links"
    [nodes]="nodes"
    [clusters]="clusters"
    [curve]="curve"
    [layout]="layoutClusters"
    [nodeWidth]="250"
    [nodeHeight]="150"
    [layoutSettings]="layoutSettings"
    [draggingEnabled]="true"
    [autoCenter]="autoCenter"
    [enableZoom]="true"
    [autoZoom]="autoZoom"
    [animate]="false"
    [update$]="updateGraph$"
    [ngClass]="graphOrientation$ | async"
>
    <ng-template #defsTemplate>
        <svg:marker id="arrow" viewBox="0 -5 10 10" refX="8" refY="0" markerWidth="4" markerHeight="4" orient="auto">
            <svg:path d="M0,-5L10,0L0,5" class="arrow-head" />
        </svg:marker>
    </ng-template>
    <ng-template #nodeTemplate let-node>
        @if (!node.hidden) {
        <svg:g class="node" xmlns="http://www.w3.org/2000/xhtml" width="350" height="210">
            <svg:foreignObject width="300" height="210">
                <mat-card
                    class="node-card"
                    data-tfa
                    [ngStyle]="getStyles(node)"
                    (click)="onNodeClick(node)"
                    [class.selected]="node.id === selection?.id"
                >
                    <mat-card-title class="node-card-label">{{ node.label }}</mat-card-title>
                    <span>{{ node.data.role }}</span>
                    <span>{{ node.data.office }}</span>
                    @if (node.data.objetMaquette.pia; as pia) { @if (pia.actif) {
                    <mat-icon matTooltip="Point d'inscription administrative" class="icone-pia" color="accent" data-tfa="icone-pia"
                        >person_pin</mat-icon
                    >
                    } @if (!pia.actif) {
                    <mat-icon
                        matTooltip="Point d'inscription administrative inactif"
                        class="icone-pia inactif"
                        color="accent"
                        data-tfa="icone-pia-inacif"
                        >group_off</mat-icon
                    >
                    } } @if (node.data.objetMaquette.valide) {
                    <mat-icon matTooltip="Objet validé" class="icone-valide" color="accent" data-tfa="icone-valide">check</mat-icon>
                    } @if (node.data.objetMaquette.mutualise) {
                    <mat-icon matTooltip="Mutualisé" class="icone-mutualise" data-tfa="icone-mutualise">check</mat-icon>
                    } @if (node.data.objetMaquette.enfants?.length) {
                    <button
                        data-tfa="toggle-enfants-button"
                        class="button-enfants"
                        (click)="$event.stopImmediatePropagation(); toggleEnfants(node)"
                        mat-mini-fab
                    >
                        <mat-icon matTooltip="afficher/cacher les enfants" class="icone-enfants" data-tfa="icone-enfants">{{
                            node.enfantsCaches ? 'expand_more' : 'expand_less'
                        }}</mat-icon>
                    </button>
                    }
                </mat-card>
            </svg:foreignObject>
        </svg:g>
        }
    </ng-template>
    <ng-template #linkTemplate let-link>
        @if (!link.data.hidden) {
        <svg:g class="edge">
            <svg:path
                class="line"
                stroke-width="4"
                [attr.stroke-dasharray]="link.data.strokeDasharray"
                [attr.marker-end]="link.data.enfantDeGroupement ? '' : 'url(#arrow)'"
            ></svg:path>
            <svg:text class="edge-label" text-anchor="middle">
                <textPath class="text-path" [attr.href]="'#' + link.id" [style.dominant-baseline]="link.dominantBaseline" startOffset="50%">
                    {{ link.label }}
                </textPath>
            </svg:text>
        </svg:g>
        }
        <!-- <svg:g class="linkMidpoint" *ngIf="link.midPoint" [attr.transform]="'translate(' + link.midPoint.x + ',' + link.midPoint.y + ')'">
                          <ellipse rx="30" ry="10" />
                          <svg:text alignment-baseline="central">{{ link.data?.linkText }}</svg:text>
                            </svg:g> -->
    </ng-template>
    <ng-template #clusterTemplate let-cluster>
        @if (!cluster.data.hidden) {
        <svg:g class="node cluster">
            <svg:rect
                rx="5"
                ry="5"
                [attr.width]="cluster.dimension.width"
                [attr.height]="cluster.dimension.height"
                [attr.fill]="'#7356ed'"
            />
        </svg:g>
        }
    </ng-template>
</ngx-graph>
}
<mat-card id="graph-legende" data-tfa="graph-legende" class="mat-elevation-z8">
    <div class="legende-container" mat-card-content>
        <ul>
            <li class="square-legende formation">Formation</li>
            <li class="square-legende objet-formation">Objet de formation</li>
            <li class="square-legende groupement">Groupement</li>
            <li class="square-legende groupement-content">Contenu du groupement</li>
            <li class="icon-legende line-2">
                <svg height="24" width="24" aria-hidden="true">
                    <defs>
                        <marker id="head" orient="auto" markerWidth="2" markerHeight="4" refX="0.1" refY="2">
                            <path d="M0,0 V4 L2,2 Z" fill="black" />
                        </marker>
                    </defs>
                    <path id="arrow-line" marker-end="url(#head)" stroke-width="2" fill="none" stroke="#666" d="M25,5, 10,5, 10 20" />
                </svg>
                Obligatoire
            </li>
            <li class="icon-legende line-2">
                <svg height="24" width="24" aria-hidden="true">
                    <defs>
                        <marker id="head" orient="auto" markerWidth="2" markerHeight="4" refX="0.1" refY="2">
                            <path d="M0,0 V4 L2,2 Z" fill="black" />
                        </marker>
                    </defs>

                    <path
                        id="arrow-line"
                        marker-end="url(#head)"
                        stroke-width="2"
                        stroke-dasharray="4 2"
                        fill="none"
                        stroke="#666"
                        d="M25,5, 10,5, 10 20"
                    />
                </svg>
                Facultatif
            </li>
            <li class="icon-legende line-3">
                <mat-icon class="icone-enfants" data-tfa="icone-enfants-legende">expand_more</mat-icon>Plier/déplier les enfants
            </li>
            <li class="icon-legende line-3">
                <mat-icon class="icone-pia" color="accent" data-tfa="icone-pia">person_pin</mat-icon>Point d'inscription administrative
            </li>
            <li class="icon-legende line-3">
                <mat-icon class="icone-pia inactif" color="accent" data-tfa="icone-pia-inactif">group_off</mat-icon>Point d'inscription
                administrative inactif
            </li>
            <li class="icon-legende line-3">
                <mat-icon class="icone-valide" color="accent" data-tfa="icone-valide">check</mat-icon>Validé
            </li>
            <!-- A remettre si le back envoie le flag un jour -->
            <!-- <li class="icon-legende">
                              <mat-icon class="icone-mutualise" data-tfa="icone-mutualise">share</mat-icon>Mutualisé
                            </li> -->
        </ul>
    </div>
</mat-card>
